import React, { FC } from 'react';

import { Image as ImageComponent } from '@lglp/components';
import { LinkType, Image } from '@lglp/prismic-client';
import { useTranslation } from 'react-i18next';

import { HEADER } from 'translations';

import { ROUTE_KEY, getUrlForRouteKey } from '../../../config/routes';
import { LA_POSTE_LOGO } from '../../../helpers/assets';
// import LogoGLPHorizontal from '../../Icons/LogoGLPHorizontal';
import { LinkedComponent } from '../../LinkedComponent';
import styles from './HeaderLogo.module.scss';

type HeaderLogoProps = {
  image?: Image;
};
export const HeaderLogo: FC<HeaderLogoProps> = ({ image }) => {
  const { t, i18n } = useTranslation();
  return (
    <LinkedComponent
      className={styles.home}
      link={{
        linkType: LinkType.Web,
        url: getUrlForRouteKey(ROUTE_KEY.HOME, i18n.language),
      }}
    >
      {image && (
        <>
          <ImageComponent
            className={styles.desktopLogo}
            src={image.src}
            alt={image.alt}
            fit
          />
          <ImageComponent
            className={styles.tabletLogo}
            src={image.thumbnail.tablet.src}
            alt={image.alt}
            fit
          />
          <ImageComponent
            className={styles.mobileLogo}
            src={image.thumbnail.mobile.src}
            alt={image.alt}
            fit
          />
        </>
      )}
      {!image && (
        <ImageComponent
          className={styles.logo}
          src={LA_POSTE_LOGO}
          alt={t(HEADER.LOGO_ALTERNATIVE_TEXT)}
          fit
        />
        /**
         * TODO : replace with this logo after new logo MEP
         * <LogoGLPHorizontal />}
         */
      )}
    </LinkedComponent>
  );
};
